import { EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
var IvrActionsComponent = /** @class */ (function () {
    function IvrActionsComponent() {
        this.removeIvrAction = new EventEmitter();
    }
    Object.defineProperty(IvrActionsComponent.prototype, "msisdns", {
        set: function (msisdns) {
            this._msisdns = msisdns.filter(function (number) { return !!number.msisdn && !number.msisdn.includes('webcall'); });
        },
        enumerable: true,
        configurable: true
    });
    IvrActionsComponent.prototype.removeAt = function (index) {
        this.removeIvrAction.next(index);
    };
    Object.defineProperty(IvrActionsComponent.prototype, "form", {
        get: function () {
            return this.ivrActionsFormWrapper.get('menus.0').get('menuEntries');
        },
        enumerable: true,
        configurable: true
    });
    IvrActionsComponent.prototype.selectedMsisdn = function (msisdn) {
        return this.msisdns.find(function (number) { return number.msisdn === msisdn; });
    };
    return IvrActionsComponent;
}());
export { IvrActionsComponent };
